import cx from 'classnames';
import { InputUI } from '../../../hookForm/InputController';
import { isUserOnboarding } from '../../../gamificationTooltip/helpers';
import CloseCircleIcon from '../../../icons/closeCircleIcon';
import { FilterIconV2 } from '../../../icons/FilterIconV2';
import styles from './SearchBar.module.scss';
import icons from '../../../../assets';
import { TooltipOverlay } from '../../../../common/TooltipOverlay/TooltipOverlay';
const { SearchBarIcon, ImageScanSearchIcon } = icons;

const SearchBar = ({
  imageSearchActive,
  onImageSearchClick,
  onFilterClick,
  filterDisabled = false,
  filterActive,
  placeholder,
  className,
  onChange,
  onFocus,
  onKeyDown,
  value,
  onClear,
  size,
  renderInput,
  version,
  autoFocus=false,
  inputClassName="",
  onBlur = () => {},
}) => {
  const customClearButton = Boolean(onClear);
  const isV2 = version === '2';

  return (
    <form
      className={cx('d-flex', styles.root, className, styles[`${size}Size`])}
      onSubmit={(e) => {
        e.preventDefault();
      }}>
      {isV2 ? (
        <InputUI
          className={styles.inputV2}
          placeholder={placeholder}
          onChange={onChange}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          value={value}
          autoComplete="off"
          theme="v2"
        />
      ) : (
        <input
          className={cx(
            styles.input,
            inputClassName,
            onImageSearchClick && onFilterClick ? styles.addMoreSpace : '',
            'form-control'
          )}
          autoFocus={autoFocus}
          type="text"
          placeholder={placeholder}
          aria-label="Search"
          onChange={onChange}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          value={value}
          onBlur={onBlur}
          style={onImageSearchClick && value ? { paddingRight: 70 } : {}}
        />
      )}
      {customClearButton && value && (
        <CloseCircleIcon className={styles.searchFormClearIcon} onClick={onClear} />
      )}
      <span>
        {!isV2 && (
          <div className={styles.searchIcon}>
            <SearchBarIcon />
          </div>
        )}
        {onImageSearchClick ? (
          <TooltipOverlay step={1}
            className={cx(
              styles.filterButton,
              onFilterClick ? styles.space1 : '',
              customClearButton && value ? styles.space2 : '',
              imageSearchActive ? styles.imageSearchButtonActive : ''
            )}
            onClick={() => onImageSearchClick(!imageSearchActive)}>
            <ImageScanSearchIcon />
          </TooltipOverlay>
        ) : null}
        {onFilterClick && !isV2 && (
          <div
            className={cx(styles.filterButton, filterActive && styles.filterButtonActive)}
            onClick={filterDisabled ? null : () => (isUserOnboarding() ? {} : onFilterClick())}>
            {/* <!-- <img src="./image/Frame 1063.png" className="filter w-auto h-auto" alt="" /> --> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5969 7.2H11.3969C11.0655 7.2 10.7969 7.46863 10.7969 7.8V9C10.7969 9.33137 11.0655 9.6 11.3969 9.6H15.5969C15.9282 9.6 16.1969 9.33137 16.1969 9V8.4V7.8C16.1969 7.46863 15.9282 7.2 15.5969 7.2ZM18.5969 9H17.3969C17.3969 9.99411 16.591 10.8 15.5969 10.8H11.3969C10.4028 10.8 9.59688 9.99411 9.59688 9H5.39687C5.0655 9 4.79688 8.73137 4.79688 8.4C4.79688 8.06863 5.0655 7.8 5.39688 7.8H9.59688C9.59688 6.80589 10.4028 6 11.3969 6H15.5969C16.591 6 17.3969 6.80589 17.3969 7.8H18.5969C18.9282 7.8 19.1969 8.06863 19.1969 8.4C19.1969 8.73137 18.9282 9 18.5969 9ZM4.79688 15.6C4.79688 15.2686 5.0655 15 5.39688 15H6.59688C6.59688 14.0059 7.40276 13.2 8.39688 13.2H12.5969C13.591 13.2 14.3969 14.0059 14.3969 15H18.5969C18.9282 15 19.1969 15.2686 19.1969 15.6C19.1969 15.9314 18.9282 16.2 18.5969 16.2H14.3969C14.3969 17.1941 13.591 18 12.5969 18H8.39688C7.40276 18 6.59688 17.1941 6.59688 16.2H5.39687C5.0655 16.2 4.79688 15.9314 4.79688 15.6ZM7.79688 15.6V16.2C7.79688 16.5314 8.0655 16.8 8.39688 16.8H12.5969C12.9282 16.8 13.1969 16.5314 13.1969 16.2V15C13.1969 14.6686 12.9282 14.4 12.5969 14.4H8.39688C8.0655 14.4 7.79688 14.6686 7.79688 15V15.6Z"
                fill="currentColor"
              />
            </svg>
          </div>
        )}

        {onFilterClick && isV2 && (
          <div
            className={cx(
              styles.filterButton,
              styles.filterButtonV2,
              filterActive && styles.filterButtonActive
            )}
            onClick={filterDisabled ? null : onFilterClick}>
            <FilterIconV2 />
          </div>
        )}
      </span>
    </form>
  );
};

export default SearchBar;
